namespace $.$$ {

	const $shm_hitalama_opencode_map_chat_resized = Symbol( '$shm_hitalama_opencode_map_chat_resized' )
	const $shm_hitalama_opencode_map_chat_sized = Symbol( '$shm_hitalama_opencode_map_chat_sized' )
	const $shm_hitalama_opencode_map_chat_sessions_tools = Symbol( '$shm_hitalama_opencode_map_chat_sessions_tools' )

	export class $shm_hitalama_opencode_map_chat extends $.$shm_hitalama_opencode_map_chat {

		map_id() {
			return this.$.$mol_state_arg.value( 'map' ) ?? ''
		}

		project_id() {
			return this.$.$mol_state_arg.value( 'project' ) ?? ''
		}

		project_chat() {
			return this.$.$mol_state_arg.value( 'section' ) === 'projects' && !!this.project_id()
		}

		override server_url( next?: string ) {
			if( next !== undefined ) return next
			return this.server_url_default()
		}

		server_url_default() {
			if( this.project_chat() ) {
				return $shm_hitalama_opencode_config.agent_url( 'opencode-dev', 'http://localhost:4096' )
			}
			return $shm_hitalama_opencode_config.agent_url( 'opencode', 'http://localhost:4096' )
		}

		agent_id() {
			if( this.project_chat() ) return ''
			const agents = $mol_wire_sync( $shm_hitalama_opencode_api ).agents( this.server_url() )
			return agents.some( agent => agent.name === 'hitalama-map' ) ? 'hitalama-map' : ''
		}

		new_session_model() {
			const view = this as any as $shm_hitalama_opencode_session
			return view.model_current()
		}

		map() {
			if( this.project_chat() ) return null
			const id = this.map_id()
			if( !id ) return null
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		project() {
			const id = this.project_id()
			if( !id ) return null
			return this.$.$shm_projects_data.record( id )
		}

		project_session_id( next?: string ) {
			const project = this.project()
			if( !project ) return ''
			return this.$.$shm_projects_data.session_current( project.id, next )
		}

		session_pages() {
			if( !this.map_id() && !this.project_session_id() ) return [ this.No_map_page() ]
			return this.thinking_visible()
				? [ this.Thinking_page(), this.Chat_page() ]
				: [ this.Chat_page() ]
		}

		override Chat_page() {
			return this.page_with_sessions( this.page_with_resizer( super.Chat_page() ) )
		}

		override Thinking_page() {
			return this.page_with_width( super.Thinking_page() )
		}

		override No_map_page() {
			return this.page_with_resizer( super.No_map_page() )
		}

		page_with_resizer< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_opencode_map_chat_resized ] ) return page
			state[ $shm_hitalama_opencode_map_chat_resized ] = true

			const sub = page.sub.bind( page )
			const style = page.style.bind( page )

			page.sub = () => [ ... sub(), this.Side_resizer() ]
			page.style = () => ({
				... style(),
				width: this.width_px(),
				flexBasis: this.width_px(),
				flexGrow: '0',
				flexShrink: '0',
				minWidth: '24rem',
				position: 'relative',
			})

			return page
		}

		page_with_width< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_opencode_map_chat_sized ] ) return page
			state[ $shm_hitalama_opencode_map_chat_sized ] = true

			const style = page.style.bind( page )
			page.style = () => ({
				... style(),
				width: this.thinking_width_px(),
				flexBasis: this.thinking_width_px(),
				flexGrow: '0',
				flexShrink: '0',
				minWidth: '24rem',
			})

			return page
		}

		page_with_sessions< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state[ $shm_hitalama_opencode_map_chat_sessions_tools ] ) return page
			state[ $shm_hitalama_opencode_map_chat_sessions_tools ] = true

			const tools = page.tools.bind( page )
			page.tools = () => this.map() ? [ this.Map_sessions(), ... tools() ] : tools()

			return page
		}

		thinking_visible() {
			const view = this as any as $shm_hitalama_opencode_session
			return !!view.thinking_message_id()
		}

		thinking_width_px() {
			return `${ this.thinking_width() }px`
		}

		panel_width_px() {
			const width = this.width() + ( this.thinking_visible() ? this.thinking_width() : 0 )
			return `${ width }px`
		}

		thinking_autoselect( messages: $shm_hitalama_opencode_api_message[] ) {
			// In map chat, keep the thinking pane opt-in. Links and pending replies still select it explicitly.
		}

		thinking_open_on_send() {
			return false
		}

		thinking_open_on_message() {
			return false
		}

		map_page() {
			const id = this.map_id()
			if( !id ) return null
			try {
				const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
				return app.Maps().Book( id ).Map_page() as $shm_hitalama_map_page
			} catch( error ) {
				return null
			}
		}

		@ $mol_mem
		events() {
			return this.$.$shm_hitalama_opencode_api_events.make({
				url: ()=> this.server_url(),
				notify: $mol_const( event => this.event_handle( event ) ),
			})
		}

		events_native() {
			if( !this.session_id() && !this.project_session_id() ) return null
			return this.events().native()
		}

		@ $mol_action
		event_handle( raw: $shm_hitalama_opencode_api_event ) {
			const event = raw.payload ?? raw
			const type = event.type
			const props = event.properties ?? {}
			const session_id = props.sessionID
			const view = this as any as $shm_hitalama_opencode_session

			if( type === 'server.connected' ) {
				if( this.session_id() ) view.messages_ensure( this.session_id() )
				view.questions_ensure()
				return
			}

			if( type === 'session.created' || type === 'session.updated' ) {
				$shm_hitalama_opencode_map_sessions.session_upsert_global(
					this.server_url(),
					$shm_hitalama_opencode_map_sessions.session_from_event( props ),
				)
			}

			if( !session_id || session_id !== this.session_id() ) return

			if( type === 'message.updated' ) {
				view.message_info_upsert( session_id, props.info )
				return
			}

			if( type === 'message.removed' ) {
				view.message_remove( session_id, props.messageID )
				return
			}

			if( type === 'message.part.updated' ) {
				view.message_part_upsert( session_id, props.part )
				return
			}

			if( type === 'message.part.removed' ) {
				view.message_part_remove( session_id, props.messageID, props.partID )
				return
			}

			if( type === 'message.part.delta' ) {
				view.message_part_delta( session_id, props.messageID, props.partID, props.field, props.delta )
				return
			}

			if( type === 'question.asked' ) {
				view.question_upsert( props )
				return
			}

			if( type === 'question.replied' || type === 'question.rejected' ) {
				view.question_remove( props.requestID )
				return
			}

			if( type === 'session.idle' || type === 'session.error' || type === 'session.status' ) {
				view.session_event_status( session_id, type, props )
				view.load_messages_later( session_id, 50, true )
				$shm_hitalama_opencode_map_sessions.sessions_refresh_global( this.server_url() )
			}
		}

		@ $mol_mem
		override session_id( next?: string ) {
			const map = this.map()
			if( next !== undefined ) {
				if( map ) {
					this.map_session_id_local( map, next )
					if( next ) this.map_session_attach( map, next )
				} else {
					this.project_session_id( next )
				}
				return next
			}

			const project_session = this.project_session_id()
			if( project_session ) return project_session
			if( !map ) return ''

			const stored = this.map_session_id_local( map )
			const ids = this.map_session_ids( map )
			if( stored && ids.includes( stored ) ) return stored
			if( ids[0] ) {
				this.map_session_id_local( map, ids[0] )
				return ids[0]
			}

			const view = this as any as $shm_hitalama_opencode_session
			const session = $mol_wire_sync( $shm_hitalama_opencode_api ).create_session(
				this.server_url(),
				null,
				view.model_current(),
			) as $shm_hitalama_opencode_api_session
			$shm_hitalama_opencode_map_sessions.session_upsert_global( this.server_url(), session )
			this.map_session_attach( map, session.id )
			this.map_session_id_local( map, session.id )
			view.messages_data( session.id, [] )
			view.messages_loaded( session.id, true )
			return session.id
		}

		session_context_sync( session_id: string ) {
			const map = this.map()
			if( !map ) return

			const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
			const context = {
				session_id,
				client_id: app.mcp_client().client_id(),
				map_id: map.link().str,
				map_title: map.title(),
				url: this.$.$mol_dom_context.document?.location.href ?? '',
			}

			$mol_wire_sync( $shm_hitalama_opencode_api ).mcp_session_context(
				$shm_hitalama_opencode_config.mcp_url(),
				context,
			)
			this.map_context_prompt_send( context.session_id, context.client_id, context.map_id, context.map_title )
		}

		@ $mol_mem_key
		map_context_prompt_sent( session_id: string, next?: string ) {
			return next ?? ''
		}

		map_context_prompt_send( session_id: string, client_id: string, map_id: string, map_title: string ) {
			const stamp = [ client_id, map_id ].join( '|' )
			if( this.map_context_prompt_sent( session_id ) === stamp ) return
			this.map_context_prompt_sent( session_id, stamp )

			$mol_wire_sync( $shm_hitalama_opencode_api ).send_prompt(
				this.server_url(),
				session_id,
				[
					'Контекст Hitalama карты:',
					`session_id: ${ session_id }`,
					`client_id: ${ client_id }`,
					`map_id: ${ map_id }`,
					`map_title: ${ map_title }`,
					'Во все hitalama tools передавай session_id, client_id и map_id из этого контекста.',
				].join( '\n' ),
				null,
				true,
				this.agent_id(),
			)
		}

		map_session_id_local( map: $shm_hitalama_map, next?: string ) {
			return this.$.$mol_state_local.value< string >(
				`hitalama_opencode_map_session_id:${ map.link().str }`,
				next,
			) ?? ''
		}

		map_session_ids( map: $shm_hitalama_map ) {
			const value = map.store( 'opencode_session_ids' )
			if( Array.isArray( value ) ) return value.filter( item => typeof item === 'string' && item )
			if( typeof value === 'string' ) {
				try {
					const parsed = JSON.parse( value )
					if( Array.isArray( parsed ) ) return parsed.filter( item => typeof item === 'string' && item )
				} catch( error ) {
					return []
				}
			}
			return []
		}

		map_session_attach( map: $shm_hitalama_map, session_id: string ) {
			const ids = this.map_session_ids( map )
			if( ids.includes( session_id ) ) return ids
			const next = [ session_id, ... ids ]
			map.store( 'opencode_session_ids', next )
			return next
		}

		no_map_text() {
			return 'Откройте карту или выберите сессию проекта'
		}

	}

}
